function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_638_3947)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34 17C34 21.5087 32.2089 25.8327 29.0208 29.0208C25.8327 32.2089 21.5087 34 17 34C12.4913 34 8.1673 32.2089 4.97918 29.0208C1.79107 25.8327 0 21.5087 0 17C0 12.4913 1.79107 8.1673 4.97918 4.97918C8.1673 1.79107 12.4913 0 17 0C21.5087 0 25.8327 1.79107 29.0208 4.97918C32.2089 8.1673 34 12.4913 34 17Z",
  fill: "#3ACC63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.77351 15.7264C9.38299 15.3359 8.74982 15.3359 8.3593 15.7264C7.96878 16.1169 7.96878 16.7501 8.3593 17.1406L9.77351 15.7264ZM15.8664 23.2335L15.1593 23.9406C15.3597 24.141 15.6358 24.247 15.9188 24.2321C16.2019 24.2173 16.4653 24.083 16.6437 23.8627L15.8664 23.2335ZM26.277 11.9627C26.6245 11.5334 26.5582 10.9037 26.1289 10.5563C25.6997 10.2088 25.07 10.275 24.7225 10.7043L26.277 11.9627ZM8.3593 17.1406L15.1593 23.9406L16.5735 22.5264L9.77351 15.7264L8.3593 17.1406ZM16.6437 23.8627L26.277 11.9627L24.7225 10.7043L15.0892 22.6043L16.6437 23.8627Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_638_3947"
}, /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "white"
})));

var SvgAcceptIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAcceptIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/accept-icon.5951290f.svg";
export { ForwardRef as ReactComponent };